import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=30ab5084&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"
import style0 from "./ChatInput.vue?vue&type=style&index=0&id=30ab5084&prod&lang=less&scoped=true"
import style1 from "./ChatInput.vue?vue&type=style&index=1&id=30ab5084&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab5084",
  null
  
)

export default component.exports